import type { ClusterFieldsContentProps } from './cluster-fields-content.component';
import { ClusterFieldsContent } from './cluster-fields-content.component';
import { Container } from './cluster-popup-card.styles';

export type ClusterPopupCardProps = ClusterFieldsContentProps;

const ClusterPopupCard = (props: ClusterPopupCardProps) => (
  <Container>
    <ClusterFieldsContent {...props} />
  </Container>
);

export default ClusterPopupCard;
